import { useTranslation } from "react-i18next";

export default function VisionSection() {
  const { t } = useTranslation();

  return (
    <section id="vision" className="w-full relative overflow-hidden">
      {/* Vision Part */}
      <div className="relative w-full py-24 md:py-32">
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://public.readdy.ai/ai/img_res/8226a4a9b9a2f73554d84bc7352cb784.jpg"
            alt="New Jersey Vision"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-[#1a1a1a]/80" />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <p className="text-[#BF9B5E] text-xs font-semibold tracking-[0.3em] uppercase mb-4">
            {t("vision_label")}
          </p>
          <h2 className="text-white text-4xl md:text-6xl font-bold leading-tight mb-10">
            {t("vision_title")}
          </h2>
          <p className="text-white/80 text-base md:text-lg leading-relaxed mb-6">
            {t("vision_text1")}
          </p>
          <p className="text-white/80 text-base md:text-lg leading-relaxed">
            {t("vision_text2")}
          </p>
        </div>
      </div>

      {/* Organizer Part */}
      <div className="w-full bg-[#f8f6f2] py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* Text */}
            <div>
              <p className="text-[#BF9B5E] text-xs font-semibold tracking-[0.3em] uppercase mb-4">
                {t("organizer_label")}
              </p>
              <h2 className="text-[#1a1a1a] text-4xl md:text-5xl font-bold leading-tight mb-6">
                {t("organizer_title")}
              </h2>
              <p className="text-gray-600 text-base leading-relaxed mb-8">
                {t("organizer_text")}
              </p>

              {/* Founder Card */}
              <div className="bg-white p-8 mb-8">
                <div className="flex items-start gap-5">
                  <div className="w-16 h-16 flex-shrink-0 flex items-center justify-center bg-[#1a1a1a] rounded-full">
                    <i className="ri-user-line text-white text-2xl" />
                  </div>
                  <div>
                    <p className="text-[#BF9B5E] text-xs font-semibold tracking-widest uppercase mb-1">
                      {t("organizer_founder_label")}
                    </p>
                    <p className="text-[#1a1a1a] text-xl font-bold mb-3">
                      {t("organizer_founder_name")}
                    </p>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      {t("organizer_founder_bio")}
                    </p>
                  </div>
                </div>
              </div>

              <div className="border-l-4 border-[#BF9B5E] pl-5">
                <p className="text-gray-600 text-base italic leading-relaxed">
                  {t("organizer_mission")}
                </p>
              </div>
            </div>

            {/* Image */}
            <div className="relative">
              <div className="w-full h-[480px] overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/96a0c724104ef419e66a29be1c3abef3/707693a028217b88c75423d8bbc7db34.png"
                  alt="Organizer"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-24 h-24 bg-[#BF9B5E] -z-10" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
